import { Controller } from 'stimulus'

export default class extends Controller
  connect: ->
    @handleSelect()

  handleSelect: ->
    @hideAndDisableAllFieldsets()

    if selectedOption = @element.options[@element.selectedIndex]
      if selectedOptionFieldsetId = selectedOption.dataset['targetFieldsetId']
        if matchingFieldset = document.querySelector("fieldset##{selectedOptionFieldsetId}")
          matchingFieldset.hidden = false
          matchingFieldset.disabled = false

  # Find all the fieldsets on the page whose IDs are referenced in the options
  # of our select target. Hide and disable all of them.
  hideAndDisableAllFieldsets: ->
    for option in @element.options
      if optionFieldsetId = option.dataset['targetFieldsetId']
        if matchingFieldset = document.querySelector("fieldset##{optionFieldsetId}")
          matchingFieldset.hidden = true
          matchingFieldset.disabled = true